import React from "react";
import { Broadcast, MapPin, TrendUp, Check } from "@phosphor-icons/react";
import ComingSoonShell from "@/components/ComingSoonShell";

/**
 * Radar di Zona — teaser. La feature richiede un servizio di raccolta
 * inserzioni (~€20/mese) per dati reali e legali. Per ora pagina "In arrivo"
 * con bottone "Avvisami" che traccia l'interesse via /api/ideas.
 */
export default function RadarComingSoon() {
  return (
    <ComingSoonShell
      testid="radar-coming-soon"
      title="Cosa succede nelle tue zone, ogni mattina."
      intro={<>Aggiungi 1-5 zone (es. <em>"Bergamo · Borgo Santa Caterina"</em>). Ogni mattina ricevi una sola schermata: nuovi annunci, ribassi, immobili venduti. Il Bloomberg degli agenti immobiliari.</>}
      preview={(
        <>
          <div className="flex items-center gap-2 mb-4 pr-20">
            <MapPin size={14} weight="duotone" className="text-[#7C8B6E]" />
            <div className="text-[13px] font-semibold text-[#1C1C1A]">
              Bergamo · Borgo Santa Caterina
            </div>
            <div className="text-[11px] text-[#9A968B]">· vendita case</div>
          </div>
          <div className="grid grid-cols-3 gap-2.5">
            {[
              { label: "Nuovi", val: "3", tone: "emerald", hint: "annunci comparsi" },
              { label: "Ribassi", val: "2", tone: "amber", hint: "prezzo ridotto" },
              { label: "Venduti", val: "1", tone: "blue", hint: "spariti dal portale" },
            ].map((s) => (
              <div
                key={s.label}
                className={`rounded-xl p-3 text-center ${
                  s.tone === "emerald" ? "bg-emerald-50 border border-emerald-200" :
                  s.tone === "amber" ? "bg-amber-50 border border-amber-200" :
                  "bg-blue-50 border border-blue-200"
                }`}
              >
                <div className={`text-[28px] font-semibold leading-none tracking-tight ${
                  s.tone === "emerald" ? "text-emerald-700" :
                  s.tone === "amber" ? "text-amber-700" :
                  "text-blue-700"
                }`}>{s.val}</div>
                <div className="mt-1 text-[10.5px] uppercase tracking-[0.14em] font-bold text-[#3A3A36]">
                  {s.label}
                </div>
                <div className="text-[10.5px] text-[#6B6A65] mt-0.5">{s.hint}</div>
              </div>
            ))}
          </div>
        </>
      )}
      whyNotYet="Per dare dati reali e aggiornati ogni mattina serve un servizio che raccolga le inserzioni in modo continuo e legale. Lo attiviamo nei prossimi mesi, quando avremo abbastanza agenti che lo richiedono — così il costo del servizio è sostenibile. Gli agenti già iscritti adesso avranno priorità di accesso."
      whatItWillDo={[
        { icon: TrendUp, label: "Ribassi di prezzo", body: "Sapere chi ha tagliato il prezzo del 5% nella tua zona — possibile cliente per i tuoi acquirenti in attesa." },
        { icon: Broadcast, label: "Nuovi annunci", body: "Le novità del giorno, filtrate per le tue zone preferite — niente più aprire 4 portali ogni mattina." },
        { icon: Check, label: "Venduti / ritirati", body: "Capire la velocità di vendita reale di una zona, per dare prezzi più realistici ai venditori." },
      ]}
      interestSlug="radar"
      interestTitle="Radar di Zona attivo"
    />
  );
}
